import BaseCommand from "@/models/api/commands/BaseCommand";

export class CopyAttributesFromBookingItemCommand extends BaseCommand {
  CommandName = "CopyAttributesFromBookingItem";
  Command: unknown;
  constructor(sessionId: string, operationId: string, bookingItemId: number, orderItemId: string) {
    super(sessionId, operationId);
    this.Command = { BookingItemId: bookingItemId, OrderItemId: orderItemId };
  }
}
